import * as Blockly from 'blockly/core'

export function registerEndBlocks() {
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'end_stop_all',
      message0: '🛑 berhenti semua',
      previousStatement: null,
      nextStatement: null,
      colour: 0,
      tooltip: 'Hentikan semua program',
    },
  ])
}
